import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { VentaService } from '../../../services/venta/venta.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-asignacion-vendedor',
  templateUrl: './asignacion-vendedor.component.html',
  styleUrls: ['./asignacion-vendedor.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class AsignacionVendedorComponent implements OnInit {

  loadMenu: boolean = true;
  load: boolean = false;
  vendedor: Array<any> = [];
  selectedSales: number = 0;
  infoEmpresa: any = {};
  idVenta?: number;
  token: any = {};
  @ViewChild('btnProcesar') btnProcesar: any;

  constructor(private venta: VentaService, private message: MessageService) { }


  ngOnInit(): void {
    this.vendedor = JSON.parse(localStorage.getItem("vendedor") ?? "[]") as Array<any>;
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    console.log(this.infoEmpresa[0].tiendaEmpleados[0].idTienda);
  }


  procesar = () => {
    // hacer perder el foco
    this.btnProcesar.nativeElement.blur();
    if ((this.idVenta ?? 0) > 0 && this.selectedSales > 0) {
      this.load = true;
      const data = {};
      this.venta.setReasignacionVendedor(this.token.token, data, this.idVenta ?? 0, this.selectedSales, this.infoEmpresa[0].tiendaEmpleados[0].idTienda)
        .subscribe({
          next: (response) => {
            if (parseInt(response as any) == 1) {
              this.message.add({ severity: 'success', summary: 'Información', detail: 'Procesamiento exitoso' })
              this.idVenta = undefined;
            }
            else
              this.message.add({ severity: 'warn', summary: 'Información', detail: 'Se ha presentado un error, intente nuevamente' })
            this.load = false;
          }, error: (error: HttpErrorResponse) => {
            this.message.add({ severity: 'warn', summary: 'Información', detail: 'Se ha presentado un error' })
            this.load = false;
          }
        });
    }
    else {
      this.message.add({ severity: 'error', summary: 'Información', detail: 'Favor ingrese la información de vendedor y/o identificador de venta' });
    }
  }

}
